import { Navigate, useLocation, useParams } from "react-router";

import { ADMIN_COMPLIANCE_PATH, MY_COMPANY_PATH } from "@/lib/compliance";

/**
 * The old Policies URLs keep working: bookmarks, and notification links sent
 * before the rename. The policy gate (`/policies/acknowledge`) is its own
 * route and is not affected.
 */
export const PoliciesRedirect = () => <Navigate to={MY_COMPANY_PATH} replace />;

/**
 * `/compliance/*` → `/my-company/*` (#1132), keeping the rest of the path and
 * the query: the task and agreement links in emails sent before the rename.
 * Mounted on a splat route, so `*` holds whatever followed `/compliance`.
 */
export const LegacyComplianceRedirect = () => {
  const rest = useParams()["*"] ?? "";
  const { search } = useLocation();
  return <Navigate to={`${MY_COMPANY_PATH}${rest ? `/${rest}` : ""}${search}`} replace />;
};

export const AdminPoliciesRedirect = () => (
  <Navigate to={`${ADMIN_COMPLIANCE_PATH}?tab=policies`} replace />
);
